export const SectionLabel = ({ children, className = "" }) => (
    <span className={`font-mono text-[11px] uppercase tracking-[0.24em] ${className}`}>
        {children}
    </span>
);
